// extracted by mini-css-extract-plugin
export default {"component":"item_component__rBmTi","icon":"item_icon__MRly3","label":"item_label__d09i+","right":"item_right__Ntud+","actionButton":"item_actionButton__0d60Y"};